<template>
	<div class="warehouse-st">
		<div class="btnbox">
			<el-button v-if="detailShow" size="small" @click="closeDetail">返回列表</el-button>
			<el-button v-if="!detailShow" type="primary" size="small" :disabled="!warehouseId" @click="onCreate">开启盘点</el-button>
		</div>
		<div class="empty-guide" v-if="ready && !warehouseId">
			<div class="empty-title">请先开通云仓</div>
			<el-button type="primary" @click="goIndex">返回云仓首页</el-button>
		</div>

		<div class="tablebox" v-if="ready && warehouseId && !detailShow">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in stateList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="id" label="单号" align="center" width="70px"></el-table-column>
					<el-table-column prop="warehouse_name" label="云仓" align="center" min-width="110px"></el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="item_count" label="总行" align="center" width="70px"></el-table-column>
					<el-table-column prop="diff_rows" label="差异行" align="center" width="70px"></el-table-column>
					<el-table-column prop="short_quantity" label="短少" align="center" width="70px"></el-table-column>
					<el-table-column prop="more_quantity" label="多出" align="center" width="70px"></el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" width="160px"></el-table-column>
					<el-table-column prop="confirm_time_str" label="确认时间" align="center" width="160px"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" width="90px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDetail(scope.row.id)">详情</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<div class="detail-wrap" v-if="ready && warehouseId && detailShow">
			<div class="detail-head">
				<div>
					<span class="name">盘点单 {{ info.id }}</span>
					<span :class="'state-' + info.state">{{ info.state_str }}</span>
					<span class="sub">共 {{ items.length }} 行，未录入 {{ pendingCount }} 行</span>
				</div>
				<div>
					<el-button v-if="info.state == 0" size="small" :loading="saving" @click="onSave">保存实盘</el-button>
					<el-button v-if="info.state == 0" type="primary" size="small" :loading="submitting" @click="onSubmit">提交待确认</el-button>
					<el-button v-if="info.state == 1" type="primary" size="small" :loading="confirming" @click="onConfirm">确认盘点</el-button>
					<el-button v-if="info.state == 0 || info.state == 1" size="small" :loading="canceling" @click="onCancel">取消盘点</el-button>
				</div>
			</div>
			<div class="scan-row" v-if="info.state == 0">
				<el-input ref="scanInput" v-model="scanCode" size="small"
					placeholder="扫码计数：扫一次对应尺码实盘 +1"
					clearable @keyup.enter.native="onScan"></el-input>
			</div>
			<div class="tip" v-if="info.state == 1">短少将按综合拿货价从保证金赔付卖家，卖家到手=供货价全额。多出默认归自己，可改为归供应商补录入仓。</div>
			<el-table ref="itemTable" :data="items" border size="mini" max-height="560" row-key="id"
				:row-class-name="scanRowClass">
				<el-table-column label="图" width="64" align="center">
					<template slot-scope="scope">
						<img v-if="scope.row.product_image" class="thumb" :src="scope.row.product_image">
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column prop="style_number" label="款号" min-width="120"></el-table-column>
				<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
				<el-table-column prop="barcode" label="条码" min-width="120"></el-table-column>
				<el-table-column prop="system_quantity" label="系统" width="70" align="center"></el-table-column>
				<el-table-column label="实盘" width="110" align="center">
					<template slot-scope="scope">
						<el-input v-if="info.state == 0" v-model="scope.row.actual_input" size="mini"></el-input>
						<span v-else>{{ scope.row.actual_quantity < 0 ? '未录入' : scope.row.actual_quantity }}</span>
					</template>
				</el-table-column>
				<el-table-column label="差异" width="70" align="center">
					<template slot-scope="scope">{{ diffText(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="多出归属" min-width="280" align="center">
					<template slot-scope="scope">
						<template v-if="info.state == 1 && moreQty(scope.row) > 0">
							<el-radio-group v-model="scope.row.handle_more" size="mini">
								<el-radio :label="2">归自己</el-radio>
								<el-radio :label="3">归供应商</el-radio>
							</el-radio-group>
							<div class="more-form" v-if="scope.row.handle_more == 3">
								<el-input v-model="scope.row.seller_uid" size="mini" placeholder="卖家UID"></el-input>
								<el-input v-model="scope.row.shop_id" size="mini" placeholder="渠道ID"></el-input>
								<el-input v-model="scope.row.unit_cost_yuan" size="mini" placeholder="供货价(元)"></el-input>
							</div>
						</template>
						<span v-else>{{ scope.row.handle_state_str || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="handle_remark" label="备注" min-width="140"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'WarehouseStocktaking',
		inject: ['appdata'],
		data() {
			return {
				ready: false,
				warehouseId: '',
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					state: ''
				},
				stateList: [
					{ id: 0, name: '盘点中' },
					{ id: 1, name: '待确认' },
					{ id: 2, name: '已确认' },
					{ id: 3, name: '已取消' }
				],
				detailShow: false,
				info: {},
				items: [],
				saving: false,
				submitting: false,
				confirming: false,
				canceling: false,
				stockMap: {},
				scanCode: '',
				lastScanCode: '',
				lastScanAt: 0,
				lastScanItemId: '',
				highlightId: ''
			}
		},
		computed: {
			pendingCount() {
				return this.items.filter(function(row) {
					return row.actual_quantity == -1 && (row.actual_input === '' || row.actual_input == null)
				}).length
			}
		},
		mounted() {
			this.loadWarehouse()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			diffText(row) {
				if (this.info.state == 0) {
					if (row.actual_input === '' || row.actual_input == null) {
						return '-'
					}
					var actual = Number(row.actual_input)
					if (isNaN(actual)) {
						return '-'
					}
					return actual - Number(row.system_quantity || 0)
				}
				if (row.actual_quantity == -1) {
					return '-'
				}
				return row.diff_quantity
			},
			moreQty(row) {
				if (row.actual_quantity == -1) {
					return 0
				}
				return Math.max(0, Number(row.diff_quantity || 0))
			},
			scanRowClass({ row }) {
				return row && row.id === this.highlightId ? 'scan-hit' : ''
			},
			normalizeBarcode(code) {
				return String(code || '').trim()
			},
			focusScan() {
				this.$nextTick(() => {
					if (this.$refs.scanInput && this.$refs.scanInput.focus) {
						this.$refs.scanInput.focus()
					}
				})
			},
			scrollToRow(row) {
				var self = this
				this.$nextTick(function() {
					var table = self.$refs.itemTable
					if (!table || !row) {
						return
					}
					var idx = self.items.indexOf(row)
					if (idx < 0) {
						idx = self.items.findIndex(function(item) {
							return item.id === row.id
						})
					}
					var wrap = (table.$refs && table.$refs.bodyWrapper) || table.bodyWrapper
					if (!wrap && table.$el) {
						wrap = table.$el.querySelector('.el-table__body-wrapper')
					}
					var rows = wrap ? wrap.querySelectorAll('tbody tr') : []
					if (rows[idx] && rows[idx].scrollIntoView) {
						rows[idx].scrollIntoView({ block: 'center' })
					}
				})
			},
			pickScanRow(rows) {
				if (!rows.length) {
					return null
				}
				if (rows.length === 1) {
					return rows[0]
				}
				var lastId = this.lastScanItemId
				var last = rows.filter(function(row) {
					return row.id === lastId
				})[0]
				if (last) {
					return last
				}
				var pending = rows.filter(function(row) {
					return row.actual_input === '' || row.actual_input == null
				})[0]
				return pending || rows[0]
			},
			onScan() {
				if (Number(this.info.state) !== 0) {
					return
				}
				var code = this.normalizeBarcode(this.scanCode)
				if (!code) {
					return
				}
				var now = Date.now()
				if (code === this.lastScanCode && now - this.lastScanAt < 180) {
					this.scanCode = ''
					this.focusScan()
					return
				}
				this.lastScanCode = code
				this.lastScanAt = now
				var hits = this.items.filter(function(row) {
					return String(row.barcode || '').trim() === code
				})
				if (!hits.length) {
					this.$message.warning('盘点单无此条码')
					this.scanCode = ''
					this.focusScan()
					return
				}
				var row = this.pickScanRow(hits)
				var cur = Number(row.actual_input)
				if (row.actual_input === '' || row.actual_input == null || isNaN(cur) || cur < 0) {
					cur = 0
				}
				if (cur >= 999999) {
					this.$message.warning('实盘数量已达上限')
					this.scanCode = ''
					this.focusScan()
					return
				}
				cur += 1
				row.actual_input = String(cur)
				this.lastScanItemId = row.id
				this.highlightId = row.id
				this.scanCode = ''
				var tip = (row.style_number || '') + ' · ' + (row.size || '') + ' 实盘 ' + cur
				if (hits.length > 1) {
					tip = '同条码 ' + hits.length + ' 行，已计入 ' + tip
				}
				this.$message.success(tip)
				this.scrollToRow(row)
				this.focusScan()
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter.state = ''
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					this.ready = true
					if (res.data.code === 0) {
						var info = res.data.data || {}
						this.warehouseId = info.id || ''
						if (this.warehouseId) {
							if (this.$route.query.id) {
								this.openDetail(this.$route.query.id)
							} else {
								this.onlist()
							}
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			onlist() {
				var params = {
					warehouse_id: this.warehouseId,
					page: this.page,
					limit: this.pageSize
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/stocktaking_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onCreate() {
				this.$axios.get('api/cloud_warehouse/stocktaking_list', {
					params: { warehouse_id: this.warehouseId, state: 0, page: 1, limit: 1 }
				}).then(res => {
					var doing = ((res.data.data && res.data.data.list) || []).concat()
					return this.$axios.get('api/cloud_warehouse/stocktaking_list', {
						params: { warehouse_id: this.warehouseId, state: 1, page: 1, limit: 1 }
					}).then(res2 => {
						doing = doing.concat((res2.data.data && res2.data.data.list) || [])
						if (doing.length) {
							this.$message.warning('存在进行中的盘点单，请先完成或取消')
							this.openDetail(doing[0].id)
							return
						}
						this.$confirm('开启后将带出当前全部可盘库存，同仓同时只能有一张进行中盘点单。', '开启盘点', {
							confirmButtonText: '开启',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$axios.post('api/cloud_warehouse/stocktaking_create', {
								warehouse_id: this.warehouseId
							}).then(created => {
								if (created.data.code === 0) {
									var id = created.data.data && created.data.data.id
									this.$message.success('已开启盘点（' + ((created.data.data && created.data.data.item_count) || 0) + ' 行）')
									this.openDetail(id)
								} else {
									this.$message.error(apiMsg(created))
								}
							}).catch(err => {
								console.log(err)
							})
						}).catch(() => {})
					})
				}).catch(err => {
					console.log(err)
				})
			},
			openDetail(id) {
				this.$axios.get('api/cloud_warehouse/stocktaking_detail', {
					params: { stocktaking_id: id }
				}).then(res => {
					if (res.data.code !== 0) {
						this.$message.error(apiMsg(res))
						return
					}
					var data = res.data.data || {}
					this.info = data.info || {}
					this.items = (data.items || []).map(function(row) {
						return Object.assign({}, row, {
							actual_input: row.actual_quantity == -1 ? '' : String(row.actual_quantity),
							handle_more: 2,
							seller_uid: '',
							shop_id: '',
							unit_cost_yuan: ''
						})
					})
					this.detailShow = true
					this.scanCode = ''
					this.lastScanCode = ''
					this.lastScanAt = 0
					this.lastScanItemId = ''
					this.highlightId = ''
					this.loadStockMap()
					if (Number(this.info.state) === 0) {
						this.focusScan()
					}
				}).catch(err => {
					console.log(err)
				})
			},
			closeDetail() {
				this.detailShow = false
				this.info = {}
				this.items = []
				this.scanCode = ''
				this.lastScanItemId = ''
				this.highlightId = ''
				this.onlist()
			},
			loadStockMap() {
				if (!this.warehouseId) {
					return
				}
				this.$axios.get('api/cloud_warehouse/stock_list', {
					params: { warehouse_id: this.warehouseId, page: 1, limit: 500 }
				}).then(res => {
					var map = {}
					;((res.data.data && res.data.data.list) || []).forEach(function(row) {
						map[row.id] = row
					})
					this.stockMap = map
					this.items.forEach((item) => {
						var stock = map[item.stock_id]
						if (!stock) {
							return
						}
						if (!item.seller_uid) {
							item.seller_uid = stock.seller_uid || ''
						}
						if (!item.shop_id) {
							item.shop_id = stock.shop_id || ''
						}
						if (!item.unit_cost_yuan && stock.unit_cost) {
							item.unit_cost_yuan = this.fenToYuan(stock.unit_cost)
						}
					})
				}).catch(err => {
					console.log(err)
				})
			},
			onSave() {
				var items = []
				for (var i = 0; i < this.items.length; i++) {
					var row = this.items[i]
					if (row.actual_input === '' || row.actual_input == null) {
						continue
					}
					var qty = Number(row.actual_input)
					if (isNaN(qty) || qty < 0 || qty > 999999 || qty !== Math.floor(qty)) {
						this.$message.warning('实盘数量异常，请核对（款号：' + row.style_number + '）')
						return
					}
					items.push({
						item_id: row.id,
						actual_quantity: qty
					})
				}
				if (!items.length) {
					this.$message.warning('请先录入实盘数量')
					return
				}
				this.saving = true
				this.$axios.post('api/cloud_warehouse/stocktaking_save', {
					stocktaking_id: this.info.id,
					items: JSON.stringify(items)
				}).then(res => {
					this.saving = false
					if (res.data.code === 0) {
						this.$message.success('已保存 ' + ((res.data.data && res.data.data.saved) || items.length) + ' 行')
						this.openDetail(this.info.id)
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.saving = false
					console.log(err)
				})
			},
			onSubmit() {
				var pending = this.items.filter(function(row) {
					return row.actual_input === '' || row.actual_input == null
				})
				if (pending.length) {
					this.$message.warning('还有 ' + pending.length + ' 行未录入实盘数量')
					return
				}
				this.onSaveSubmit()
			},
			onSaveSubmit() {
				var items = this.items.map(function(row) {
					return {
						item_id: row.id,
						actual_quantity: Number(row.actual_input)
					}
				})
				this.submitting = true
				this.$axios.post('api/cloud_warehouse/stocktaking_save', {
					stocktaking_id: this.info.id,
					items: JSON.stringify(items)
				}).then(res => {
					if (res.data.code !== 0) {
						this.submitting = false
						this.$message.error(apiMsg(res))
						return
					}
					this.$axios.post('api/cloud_warehouse/stocktaking_submit', {
						stocktaking_id: this.info.id
					}).then(sub => {
						this.submitting = false
						if (sub.data.code === 0) {
							this.$message.success('已提交，待确认')
							this.openDetail(this.info.id)
						} else {
							this.$message.error(apiMsg(sub))
						}
					}).catch(err => {
						this.submitting = false
						console.log(err)
					})
				}).catch(err => {
					this.submitting = false
					console.log(err)
				})
			},
			onConfirm() {
				var moreItems = []
				for (var i = 0; i < this.items.length; i++) {
					var row = this.items[i]
					if (this.moreQty(row) <= 0) {
						continue
					}
					if (Number(row.handle_more) !== 3) {
						continue
					}
					var cost = yuanToFen(row.unit_cost_yuan)
					if (!row.seller_uid || !row.shop_id || isNaN(cost) || cost <= 0) {
						this.$message.warning('归供应商须补录卖家/渠道/供货价（款号：' + row.style_number + '）')
						return
					}
					moreItems.push({
						item_id: row.id,
						handle_more: 3,
						seller_uid: Number(row.seller_uid),
						shop_id: Number(row.shop_id),
						unit_cost: cost
					})
				}
				this.$confirm('确认后将执行短少赔付与多出归属，不可撤销。', '确认盘点', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var payload = { stocktaking_id: this.info.id }
					if (moreItems.length) {
						payload.more_items = JSON.stringify(moreItems)
					}
					this.confirming = true
					this.$axios.post('api/cloud_warehouse/stocktaking_confirm', payload).then(res => {
						this.confirming = false
						if (res.data.code === 0) {
							var data = res.data.data || {}
							this.$message.success('已确认：短少 ' + (data.shortfall_quantity || 0) + ' 件，多出归己 ' + (data.more_self_quantity || 0) + '、归供应商 ' + (data.more_supplier_quantity || 0))
							this.refreshBalance()
							this.openDetail(this.info.id)
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.confirming = false
						console.log(err)
					})
				}).catch(() => {})
			},
			onCancel() {
				this.$confirm('取消后无资金与库存变动，可重新开启。', '取消盘点', {
					confirmButtonText: '取消盘点',
					cancelButtonText: '返回',
					type: 'warning'
				}).then(() => {
					this.canceling = true
					this.$axios.post('api/cloud_warehouse/stocktaking_cancel', {
						stocktaking_id: this.info.id
					}).then(res => {
						this.canceling = false
						if (res.data.code === 0) {
							this.$message.success('已取消盘点')
							this.closeDetail()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.canceling = false
						console.log(err)
					})
				}).catch(() => {})
			},
			refreshBalance() {
				if (this.appdata && this.appdata.oninfo) {
					this.appdata.oninfo()
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-st {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
	}

	.detail-wrap {
		background: #fff;
		padding: 12px;
	}

	.detail-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		.name {
			font-weight: 600;
			margin-right: 10px;
		}
		.sub {
			color: #909399;
			margin-left: 10px;
		}
	}

	.scan-row {
		margin-bottom: 10px;
		max-width: 420px;
	}

	.tip {
		color: #E6A23C;
		font-size: 12px;
		margin-bottom: 10px;
	}

	/deep/ .scan-hit > td {
		background-color: #fdf6ec !important;
	}

	.thumb {
		width: 36px;
		height: 36px;
		object-fit: contain;
	}

	.more-form {
		margin-top: 6px;
		display: flex;
		gap: 6px;
	}

	.state-0 {
		color: #E6A23C;
	}
	.state-1 {
		color: #409EFF;
	}
	.state-2 {
		color: #67C23A;
	}
	.state-3 {
		color: #909399;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/stocktaking.vue